import { useContext } from 'react';
import { Context, ContextValue } from './context';

export const useTranslation = (): ContextValue => useContext(Context);
